import { helpers } from 'vuelidate/lib/validators'
import * as ruleNames from '@/components/common/inputs/constants/ruleNames'
import { Evaluators } from '@/components/common/inputs/types'
import dayjs from 'dayjs'

const TODAY = dayjs()

export const endGreaterThanStart = (evaluators: Evaluators) =>
  helpers.withParams({ type: ruleNames.SAME_AS }, () => {
    const start = TODAY.hour(evaluators.startHour.$model)
      .minute(evaluators.startMinute.$model)
      .unix()
    const end = TODAY.hour(evaluators.endHour.$model)
      .minute(evaluators.endMinute.$model)
      .unix()
    return start < end
  })
